import PrimaryCalendar from "./PrimaryCalendar";
import SettingsContentsTitle from "../Common/SettingsContentsTitle";
import CalendarList from "./CalendarList";
import CalendarAccount from "./CalendarAccount";

const Calendars = () => {
  return (
    <div className="flex flex-col max-w-[650px] self-stretch w-full h-full text-white px-[30px] gap-[30px] text-[#fff] select-none">
      <SettingsContentsTitle title="Calendars" />
      <div className="flex flex-col h-max-content self-stretch gap-[30px]">
        <PrimaryCalendar />
        <div className="flex flex-col gap-0.5">
          <CalendarAccount />
          <CalendarList />
        </div>
      </div>
    </div>
  );
};

export default Calendars;
